import React from 'react';

export default function FwSearchIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-search' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
